module.exports = __webpack_public_path__ + "static/media/gabriel_4.ed1d7a71.png";